// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"e8994f7e","190":"0625cb6e","258":"60efd360","500":"c402e7f5","600":"332eef61","968":"9bd6de5f","997":"90265df8"}[chunkId] + ".chunk.js";
};